import Vue from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import store from './store';
import Toast from "vue-toastification";
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/vendor/css/core.css'
import './assets/vendor/css/theme-default.css'
import './assets/vendor/css/pages/page-account-settings.css'
import './assets/vendor/css/pages/page-account-settings.css'
import './assets/vendor/css/pages/page-auth.css'
import './assets/vendor/css/pages/page-icons.css'
import './assets/vendor/css/pages/page-misc.css'
import './assets/vendor/css/pages/page-misc.css'
import './assets/vendor/fonts/boxicons.css'
import './assets/css/demo.css'
// Antes de admin-tables.css, que le da a Select2 el aspecto de los demás campos
import 'select2/dist/css/select2.min.css'
import './assets/css/admin-tables.css'
import './assets/js/config.js'
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "vue-toastification/dist/index.css";
import { programarRefresh } from '@/services/authService';
import './registerServiceWorker';
import './pwaInstallPrompt';

Vue.config.productionTip = false;

Vue.use(Toast, {
  position: "top-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true
});

// Configuración base de Axios
axios.defaults.baseURL = process.env.VUE_APP_API_URL;

// Interceptor para agregar el token a todas las solicitudes de Axios
axios.interceptors.request.use(
  (config) => {
    // Obtener el token del localStorage (o del store si lo prefieres)
    const token = localStorage.getItem('token') || store.state.token;
    if (token) {
      // Añadir el token al encabezado Authorization
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("⚠️ Sesión expirada. Redirigiendo al login...");      
      localStorage.removeItem('token');
      store.commit('logout');       
      if (router.currentRoute.path !== '/login') {
        router.push('/login');
      }
    }
    return Promise.reject(error);
  }
);



new Vue({
  render: h => h(App),
  store,
  router
}).$mount('#app');


const token = localStorage.getItem('token');

if (token) {
  programarRefresh(token);
}
